{
  "{platform} version {version} · update {update}": "Versión {version} para {platform} · actualización {update}",
  "{platform} version {version}": "Versión {version} para {platform}",
  "Delete my account, all personal data, and all video files streamed or uploaded online from EventLive servers": "Eliminar mi cuenta, todos mis datos personales y todos los videos transmitidos o subidos a los servidores de EventLive",
  "Delete your Account? THIS ACTION IS IRREVERSIBLE": "¿Eliminar tu cuenta? ESTA ACCIÓN ES IRREVERSIBLE",
  "You have {count} prepaid event. It's used automatically when you create an event.": {
    "one": "Tienes {count} evento prepagado. Se usa automáticamente cuando creas un evento.",
    "other": "Tienes {count} eventos prepagados. Se usa uno automáticamente cada vez que creas un evento."
  },
  "My Video Wall": "Mi muro de videos",
  "Download Everything": "Descargar todo",
  "Update Profile": "Actualizar perfil",
  "View Invoices and Manage Subscription": "Ver facturas y administrar la suscripción",
  "Reset Password": "Restablecer contraseña",
  "Contact Support": "Contactar con soporte",
  "Review EventLive": "Calificar EventLive",
  "Delete Account": "Eliminar cuenta",
  "Sign Out": "Cerrar sesión",
  "{team}'s Team": "Equipo de {team}",
  "Team": "Equipo",
  "Over {limit} in all": "Más de {limit} en total",
  "Ticketed: no limit": "Con boletos: sin límite",
  "{hours} in all": "{hours} en total",
  "MMMM YYYY": "MMMM [de] YYYY",
  "{month} (so far)": "{month} (hasta ahora)",
  "Couldn't load this month. Please try again.": "No se pudo cargar este mes. Inténtalo de nuevo.",
  "How many hours of your videos people watched each month, live and replay. Each event includes {limit} viewer-hours; ticketed events have no limit.": "Cuántas horas de tus videos vio la gente cada mes, en vivo y en grabación. Cada evento incluye {limit} horas-espectador; los eventos con boletos no tienen límite.",
  "Viewer-hours are shown to business accounts.": "Las horas-espectador se muestran a las cuentas de empresa.",
  "Couldn't load viewer-hours. Please try again later.": "No se pudieron cargar las horas-espectador. Inténtalo más tarde.",
  "No viewer-hours yet. They're updated every hour, within an hour of people watching.": "Todavía no hay horas-espectador. Se actualizan cada hora, menos de una hora después de que la gente vea tus eventos.",
  "Counted every hour from the video our CDN delivered, on every player. Months are in UTC, and an event's hours count in the month people watched. Test events aren't included.": "Se cuentan cada hora a partir del video que entregó nuestra CDN, en todos los reproductores. Los meses están en UTC y las horas de un evento cuentan en el mes en que la gente lo vio. No incluye los eventos de prueba.",
  "{extra} over {limit} this month": "{extra} por encima de {limit} este mes",
  "{extra} extra viewer-hours on {count} event over {limit}": {
    "one": "{extra} horas-espectador extra en {count} evento que supera {limit}",
    "other": "{extra} horas-espectador extra en {count} eventos que superan {limit}"
  }
}
